import React, { useEffect, useState } from 'react'
import { Table, Tab, Row, Col, ListGroup, Button, FormControl, Form, Image } from 'react-bootstrap'
import { RenderImage } from '../presentational-components/ImageViewer'
import moment from 'moment'
import 'moment/locale/de'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import { FetchBoutiqueInfosArticleTypes, FetchArticleTypeImages } from '../../fetcher'

moment.locale('de')


const NewSale = ({ addTransaction, setNewBooking, designerList, date, openAlert, setTaskName, area }) => {
    const [designer, setDesigner] = useState(null)
    const [articleType, setArticleType] = useState(null)
    const [size, setSize] = useState(null)
    const [number, setNumber] = useState(0)
    const [total, setTotal] = useState(0)
    const [remarks, setRemarks] = useState("")
    const [discount, setDiscount] = useState(0)
    const [numbersList, setNumbersList] = useState([])

    const [articleTypesList, setArticleTypesList] = useState([])
    //const [payment, setPayment] = useState(null)

    //date = new Date().toLocaleDateString()
    //const boutique = "Boutique"

    //const [designerList, setDesignerList] = useState([{ DesignerName: "Designer1", DesignerSysId: "1" }, { DesignerName: "Designer2", DesignerSysId: "2" }, { DesignerName: "Designer3", DesignerSysId: "3" }, { DesignerName: "Designer4", DesignerSysId: "4" }, { DesignerName: "Designer5", DesignerSysId: "5" }])
    //const dummySizeList = ["SizeA", "SizeB", "SizeC", "SizeD", "SizeE"]
    //const [articleTypeList, setArticleTypeList] = useState(
        //[
        //    { ArticleTypeName: "ArticleName1", ArticleTypeSysId: "ArticleSysId1", DesignerSysId: "1", Sizes: dummySizeList, PriceUnit: 9.99 },
        //    { ArticleTypeName: "ArticleName2", ArticleTypeSysId: "ArticleSysId2", DesignerSysId: "1", Sizes: dummySizeList, PriceUnit: 7.99 },
        //    { ArticleTypeName: "ArticleName3", ArticleTypeSysId: "ArticleSysId3", DesignerSysId: "2", Sizes: dummySizeList, PriceUnit: 29 },
        //    { ArticleTypeName: "ArticleName4", ArticleTypeSysId: "ArticleSysId4", DesignerSysId: "2", Sizes: dummySizeList, PriceUnit: 40 },
        //    { ArticleTypeName: "ArticleName5", ArticleTypeSysId: "ArticleSysId5", DesignerSysId: "3", Sizes: dummySizeList, PriceUnit: 42.79 }])
    
    //const dummyNumbersList= [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]

    const [articleDataReady, setArticleDataToReady] = useState(false)

    const addingImages = (articleTypeImages) => {
        let copiedArticleTypesList = [...articleTypesList]
        articleTypeImages.forEach(image => copiedArticleTypesList.filter(x => x.ArticleTypeSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setArticleTypesList(copiedArticleTypesList)
    }

    useEffect(() => {
        if (articleDataReady) {
            setTaskName("Die Bilder werden geladen")
            FetchArticleTypeImages(articleTypesList.map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert, area)
        }
    }, [articleDataReady])

    const handleSizeChange = (e, sizeToSet) => {
        e.preventDefault()

        setSize(sizeToSet)
        let amount = (articleType.Sizes.find(x => x.SizeValue == sizeToSet.SizeValue).AmountInStorage)
        let amounts = []
        for (let i = 1; i <= amount; i++) {
            amounts.push(i)
        }
        setNumbersList(amounts)
    }

    const handleSubmit = () => {
        const newTransaction = {
            designer: designer,
            articleType: articleType,
            size: size,
            number: number,
            total: total,
            remarks: remarks,
            discount: discount
        }

        addTransaction(newTransaction)
        setNewBooking(false)
    }

    const [designerFilterInput, setDesignerFilterInput] = useState("")
    const handleDesignerFilter = (e) => {
        setDesignerFilterInput(e.target.value)
    }

    const [articleTypeFilterInput, setArticleTypeFilterInput] = useState("")
    const handleArticleTypeFilter = (e) => {
        setArticleTypeFilterInput(e.target.value)
    }

    const [sizeFilterInput, setSizeFilterInput] = useState("")
    const handleSizeFilter = (e) => {
        setSizeFilterInput(e.target.value)
    }

    const [numberFilterInput, setNumberFilterInput] = useState("")
    const handleNumberFilter = (e) => {
        setNumberFilterInput(e.target.value)
    }

    const selectNumber = (value) => {
        setNumber(value)
        setTotal((articleType.PriceUnit * value + discount * value))
    }

    const selectDiscount = (value) => {
        setDiscount(value)
        setTotal((articleType.PriceUnit * number + value * number))
    }

    const handleSetDesigner = (designer) => {
        setTaskName("Die verfügbare Artikel werden geladen")
        FetchBoutiqueInfosArticleTypes(designer.DesignerSysId, setArticleTypesList, openAlert, setArticleDataToReady)
        setDesigner(prev => prev = designer)
    }

    useEffect(() => {
        console.log("handleSetDesigner articleTypesList")
        console.log(articleTypesList)
        console.log(articleTypesList.map(articleType => 
                articleType.Sizes
        ))
    }, [articleTypesList])

    const ChooseDesigner = () => {
        return (
            <div className="designerList">
                <Col className="designer-col" >
                    <FormControl className="globalSearch-booking" as="input" placeholder="Name Designer..." value={designerFilterInput} onChange={handleDesignerFilter}></FormControl>
                    <ListGroup className="listGroup" >
                        {designerList.sort((a, b) => a.DesignerName.localeCompare(b.DesignerName)).filter(x => x.DesignerName.toLowerCase().includes(designerFilterInput.toLowerCase())).map(designer =>
                            <ListGroup.Item value={designer.DesignerName} action onClick={(e) => handleSetDesigner(designer)}>
                                {designer.DesignerName}
                            </ListGroup.Item>
                        )}
                    </ListGroup>
                    {designerList.length === 0 ? "Designer werden geladen..." : ""}
                </Col>
            </div>
        )
    }

    const ChooseArticleType = () => {
        return (
            <div className="">
                <Button variant="light" onClick={() => setDesigner(null)}>{designer.DesignerName}</Button>
                <Col className="booking-articleType">
                    <FormControl className="globalSearch-booking" as="input" placeholder="Artikeltyp..." value={articleTypeFilterInput} onChange={handleArticleTypeFilter}></FormControl>
                    <div className="blocky">
                        <ListGroup className="listGroup" >
                            {articleTypesList.length === 0 ?
                                <div >
                                    <ListGroup.Item className="listGroup-item" value={"Empty"} disabled action>

                                        <Row className="nowrap">

                                            <Col className="dropdown-article">{"Die verfügbare Artikeltypen werden geladen..."}</Col>

                                        </Row>

                                    </ListGroup.Item>
                                </div> :
                                <div>
                                    {articleTypesList.sort((a, b) => a.ArticleTypeName.localeCompare(b.ArticleTypeName)).filter(x => x.DesignerSysId == designer.DesignerSysId)
                                        .filter(x => x.ArticleTypeName.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                            || x.ArticleIdFaex.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                            || x.Colour.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                            || x.ArticleNumberDesigner.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                            || parseFloat(x.PriceUnit).toFixed(2).replace('.', ',').toString().includes(articleTypeFilterInput.toLowerCase())
                                        ).map(articleType =>
                                            <div >
                                                <ListGroup.Item className="listGroup-item" value={articleType.ArticleTypeName} action onClick={(e) => setArticleType(articleType)}>

                                                    <Row className="nowrap">

                                                        <Col className="dropdown-imageColumn">{RenderImage(articleType.Image)}</Col>
                                                        <Col className="dropdown-article-smallField">{articleType.ArticleIdFaex}</Col>
                                                        <Col className="dropdown-article">{articleType.ArticleNumberDesigner}</Col>
                                                        <Col className="dropdown-article-smallField">{articleType.Colour}</Col>
                                                        <Col className="dropdown-article-smallField dropdown-article-currency">{parseFloat(articleType.PriceUnit).toFixed(2).replace('.', ',') + "€"}</Col>
                                                        <Col>{articleType.ArticleTypeName}</Col>

                                                    </Row>

                                                </ListGroup.Item>
                                            </div>
                                        )}
                                </div>}
                        </ListGroup>
                    </div>
                </Col>
            </div>
        )
    }

    const ChooseSize = () => {
        return (
            <div className="">
                <Row>
                    <Col  className="booking-size">
                        <Button variant="light" onClick={() => { setArticleType(null); setDesigner(null) }}>{designer.DesignerName}</Button>
                        <Button variant="light" onClick={() => setArticleType(null)}>{articleType.ArticleTypeName}</Button>
                        <FormControl className="globalSearch-booking listGroup-small" as="input" placeholder="Größe..." value={sizeFilterInput} onChange={handleSizeFilter}></FormControl>
                        <ListGroup className="listGroup listGroup-small" >
                            {articleType.Sizes.filter(x => x.SizeValue.toLowerCase().includes(sizeFilterInput.toLowerCase())).map(size =>
                                <ListGroup.Item value={size.SizeValue} action onClick={(e) => handleSizeChange(e, size)}>
                                    {size.SizeValue}
                                </ListGroup.Item>
                            )}
                        </ListGroup>
                    </Col>
                    <Col className="imageColumn-sale">
                        <Image className="fullimage-small" src={articleType.Image} />
                    </Col>
                </Row>
            </div>
        )
    }

    const ChooseNumber = () => {
        return (
            <div className="">
                <Row>
                    <Col className="booking-number">
                        <Button variant="light" onClick={() => { setSize(null); setArticleType(null); setDesigner(null) }}>{designer.DesignerName}</Button>
                        <Button variant="light" onClick={() => { setSize(null); setArticleType(null) }}>{articleType.ArticleTypeName}</Button>
                        <Button variant="light" onClick={() => setSize(null)}>{size.SizeValue}</Button>
                        Vorhandene Anzahl: {numbersList.length}

                        <FormControl className="globalSearch-booking listGroup-small" as="input" placeholder="Anzahl..." value={numberFilterInput} onChange={handleNumberFilter}></FormControl>
                        <ListGroup className="listGroup listGroup-small" >
                            {numbersList.filter(x => x.toString().includes(numberFilterInput)).map(number =>
                                <ListGroup.Item value={number} action onClick={(e) => selectNumber(e.target.value)}>
                                    {number}
                                </ListGroup.Item>
                            )}
                        </ListGroup>
                    </Col>
                    <Col className="imageColumn-sale">
                        <Image className="fullimage-small" src={articleType.Image} />
                    </Col>
                </Row>
            </div>
        )
    }

    const Checkout = () => {
        return (
            <div>
                <Row className="checkout-row">

                    <Row>
                        <Col>
                            <Button variant="light" className="" onClick={() => { setDesigner(null); setArticleType(null); setSize(null); setNumber(0); setTotal(0) }}>{designer.DesignerName}</Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Button variant="light" className="" onClick={() => { setArticleType(null); setSize(null); setNumber(0); setTotal(0) }}>{articleType.ArticleTypeName}</Button>
                            <Button variant="light" className="" onClick={() => { setSize(null); setNumber(0); setTotal(0) }}>{size.SizeValue}</Button>
                            <Button variant="light" className="" onClick={() => { setNumber(0); setTotal(0) }}>{number}</Button>
                            <Button variant="light" disabled className="">{parseFloat(articleType.PriceUnit).toFixed(2).replace('.', ',') + "€"}</Button>
                        
                            <Form>
                                <Form.Group>
                                    <Form.Label>Preisanpassung:</Form.Label>
                                    <FormControl className="form currency-input" defaultValue="0.00" type="number" step=".01"
                                        onChange={(e) => selectDiscount(e.target.value)} size="md" />

                                    <Form.Label>Endpreis:</Form.Label>
                                    <Button variant="light" disabled className="">{parseFloat(total).toFixed(2).replace('.', ',') + "€"}</Button>
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>

                    <Col className="imageColumn-sale">
                        <Image className="fullimage-small" src={articleType.Image} />
                    </Col>
                    <Col>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Bemerkung</Form.Label>
                                <Form.Control as="textarea" rows={3} onChange={(e) => setRemarks(e.target.value)}/>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>

                
                {/*<Row className="checkout-row">*/}
                {/*    <Col sm="4">*/}
                {/*        <FormControl as="select" onChange={(e) => setPayment(e.target.value)}>*/}
                {/*            <option defaultValue selected disabled>Zahlungsmittel</option>*/}
                {/*            {dummyPaymentList.map(payment =>*/}
                {/*                <option>{payment}</option>*/}
                {/*            )}*/}
                {/*        </FormControl>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Button variant="success" className="">&#43; Neu</Button>*/}
            </div>
        )
    }

    const reset = () => {
        setDesigner(null)
        setArticleType(null)
        setSize(null)
        setNumber(0)
        setTotal(0)
    }

    return (
        <div >
            <h1 className="tablet-center">Verkauf buchen</h1>
            <div className="flex-linebreak"></div>

            <div className="tablet-transactions">
                <Table>
                    <thead>
                        <th>{moment(date).format("DD.MM.YYYY")}</th>
                        {/*<th>{boutique}</th>*/}
                        {/*<th>{payment !== null ? payment : "Zahlung"}</th>*/}
                        <th>{number !== 0 ? number : "Anzahl"}</th>
                        <th>{parseFloat(total).toFixed(2).replace('.', ',') + "€"}</th>
                    </thead>
                </Table>
                <div>

                    {designer === null
                        ? ChooseDesigner()
                        : articleType === null
                            ? ChooseArticleType()
                            : size === null
                                ? ChooseSize()
                                : number === 0
                                    ? ChooseNumber()
                                    : Checkout() }

                </div>
                <div className="bookingButtons">
                    <Button variant="secondary" onClick={() => { reset(); setNewBooking(false) }}>Abbrechen</Button>
                    <Button variant="secondary" disabled={number === null || number === 0 ? true : false} onClick={handleSubmit}>Buchen</Button>
                </div>
            </div>
        </div>
    )
}

export default NewSale

